// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/BezierSans.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/BezierSans.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/fonts/BezierSans.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/fonts/BezierSansBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Bezier Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
         url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
    font-weight: normal;
    font-style: normal;

    font-family: 'Bezier Sans Bold';
    src:
         url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  body {
    font-family: 'Bezier Sans', sans-serif;
  }
/* Ваши стили */

.container-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    /* height: 100vh; /* Высота экрана целиком */
}

.container {
    width: 100%;
    height: 100%;
    padding-bottom: 5%;
    /*padding: 80px 0px 64px;*/
    background-color: #ffffff;
    margin: 0 auto; /* Центрируем контейнер по горизонтали */
    border-radius: 20px;
    display: flex;
    position: relative; /* Для позиционирования псевдоэлемента */
}

.container::before {
    content: '';
    position: absolute;
    /* bottom: 0; /* Подсветка снизу */
    /* left: 0; */
    width: 100%;
    height: 20px; /* Высота подсветки */
    box-sizing: border-box; /* Учитываем border в размерах */
    pointer-events: none; /* Предотвращаем взаимодействие с псевдоэлементом */
}

.partners {

    margin-top: 20px;
    padding: 20px;
    width: 100%; /* Занимаем всю доступную ширину контейнера .container */
    box-sizing: border-box; /* Учитываем padding в общей ширине */
    text-align: center; /* Выравниваем текст по центру */
}

.text-container {

    justify-content: center; /* Центрируем контент горизонтально */
    align-items: center;
    padding-top: 30px;
    margin: 0 auto;
    margin-bottom: 32px; /* Отступ от текста 1174x32 */
}

.text-40,
.text-30,
.text-20 {
    font-family: 'Bezier Sans', sans-serif;

}

.text-40 {
    font-family: 'Bezier Sans Bold';
    padding-top: 8%;
    font-size: 40px;
    margin-bottom: 10px;
    line-height: 60px;
}



.text-20 {
    font-family: 'Bezier Sans', sans-serif;
    justify-content: left; 
    font-size: 20px;
    padding-left: 10%;
    padding-right: 10%;
}

.padding-button {
    padding: 20px;
}

.buttons-container {
    font-family: 'Bezier Sans', sans-serif;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
    width: 100%; 
    margin: 0 auto;
    margin-top: 20px;
 /* Равномерное распределение между кнопками */
    padding-bottom: 10%;
}

.button-image{
    margin-top: 5px;
    width: 100px; /* Задайте нужные размеры */
    height: auto;
    display: block;
    margin-left: auto;
    margin-right: auto;
    justify-content: center;
    align-items: center;
}

.partner-description {
    font-family: 'Bezier Sans', sans-serif;
    margin-top: 10px;
    font-size: 14px;
    color: #666;
    text-align: center;
    line-height: 1.5;
}

.partner-text-k{
    font-family: 'Bezier Sans', sans-serif;
    font-size: 14px;
    margin-left: 8%;
    margin-right: 8%;
    margin-top: 5%;
}

.buttons-container button {
    width: 390px; /* 376.03pxШирина кнопки */
    height: 400px; /*457.2px Высота кнопки */
    padding: 0; /* Убираем внутренние отступы */
    font-size: 16px;
    background-color: white; /* Белый фон */
    color: black; /* Черный текст */
    border: 1px solid #0014ff; /* Черная обводка */
    cursor: pointer;
    box-sizing: border-box; /* Учитываем padding и border в общей ширине */
    overflow: hidden; /* Обрезаем содержимое, выходящее за пределы кнопки */
    position: relative; /* Позиционируем внутренние элементы относительно кнопки */
    /*font-family: 'Bezier Sans Bold';*/
    font-weight: bold;
    border-radius: 40px;
}

.buttons-container button:hover {
    background-color: #0014ff; /* Темно-серый фон при наведении */
    color: white; /* Белый текст при наведении */
}

.partner-button {

    width: 772.03px;
    height: 51px;
    margin: 20px auto 0; /* Отступ снизу для разделения кнопок */
    padding: 10px 20px;
    font-size: 16px;
    background-color: #0080ff;/* Светло-серый фон */
    color: rgb(246, 253, 255); /* Черный текст */
    border: none; /* Убираем обводку */
    cursor: pointer;
    box-sizing: border-box; /* Учитываем padding и border в общей ширине */
    font-weight: bold;
    border-radius: 30px;
}

/* Media query для мобильных устройств */
@media screen and (max-width: 768px) {

    .partners {
        padding-bottom: 20%;
        height: auto;
    }
    .padding-button {
        flex-direction: column; /* Столбцовое расположение кнопок на мобильных устройствах */
        align-items: center; /* Центрируем кнопки по центру */
        /*margin-top: 20px;*/
        width: calc(100% - 30px); /* Полная ширина кнопок на мобильных устройствах с небольшим отступом */
        max-width: 300px; /* Максимальная ширина кнопок, чтобы не были слишком широкими */
        height: auto; /* Увеличенная высота для мобильных устройств */
        font-size: 24px; /* Увеличенный размер шрифта для лучшей читаемости */
        padding: 20px;
        font-weight: bold;
    }

    .text-40,
    .text-30,
    .text-20 {
        /*font-family: 'BezierSans', sans-serif;
        font-weight: bold;
        */
        
        max-width: 100%;
    }

    .buttons-container {
        flex-direction: column; /* Столбцовое расположение кнопок на мобильных устройствах */
        align-items: center; /* Центрируем кнопки по центру */
    }

    .buttons-container button {
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        /*width: calc(100% - 40px); /* Полная ширина кнопок на мобильных устройствах с небольшим отступом */
        max-width: 300px; /* Максимальная ширина кнопок, чтобы не были слишком широкими */
        height: auto; /* Увеличенная высота для мобильных устройств */
        font-size: 24px; /* Увеличенный размер шрифта для лучшей читаемости */
        padding: 20px; /* Увеличенный отступ для лучшей зоны нажатия */
        font-family: 'BezierSans', sans-serif;

    }

    .partner-button {
        /*width: calc(100% - 30px); /* Полная ширина кнопки "партнёр" на мобильных устройствах с небольшим отступом */
        max-width: 300px; /* Максимальная ширина кнопки "партнёр", чтобы не была слишком широкой */
        height: 70px; /* Увеличенная высота кнопки "партнёр" на мобильных устройствах */
        font-size: 18px; /* Увеличенный размер шрифта для лучшей читаемости */
        padding: 15px 20px; /* Увеличенный отступ для лучшей зоны нажатия */
        font-family: 'BezierSans', sans-serif;

    }

    
}
`, "",{"version":3,"sources":["webpack://./src/styles/Partners.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B;;mEAEgE;IAChE,mBAAmB;IACnB,kBAAkB;;IAElB,+BAA+B;IAC/B;mEACoE;IACpE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,sCAAsC;EACxC;AACF,eAAe;;AAEf;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,yBAAyB;IACzB,cAAc,EAAE,wCAAwC;IACxD,mBAAmB;IACnB,aAAa;IACb,kBAAkB,EAAE,wCAAwC;AAChE;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kCAAkC;IAClC,aAAa;IACb,WAAW;IACX,YAAY,EAAE,qBAAqB;IACnC,sBAAsB,EAAE,gCAAgC;IACxD,oBAAoB,EAAE,mDAAmD;AAC7E;;AAEA;;IAEI,gBAAgB;IAChB,aAAa;IACb,WAAW,EAAE,wDAAwD;IACrE,sBAAsB,EAAE,qCAAqC;IAC7D,kBAAkB,EAAE,gCAAgC;AACxD;;AAEA;;IAEI,uBAAuB,EAAE,qCAAqC;IAC9D,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,mBAAmB,EAAE,6BAA6B;AACtD;;AAEA;;;IAGI,sCAAsC;;AAE1C;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,iBAAiB;AACrB;;;;AAIA;IACI,sCAAsC;IACtC,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sCAAsC;IACtC,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,cAAc;IACd,gBAAgB;CACnB,6CAA6C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY,EAAE,2BAA2B;IACzC,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY,EAAE,0BAA0B;IACxC,aAAa,EAAE,yBAAyB;IACxC,UAAU,EAAE,+BAA+B;IAC3C,eAAe;IACf,uBAAuB,EAAE,cAAc;IACvC,YAAY,EAAE,iBAAiB;IAC/B,yBAAyB,EAAE,mBAAmB;IAC9C,eAAe;IACf,sBAAsB,EAAE,8CAA8C;IACtE,gBAAgB,EAAE,qDAAqD;IACvE,kBAAkB,EAAE,0DAA0D;IAC9E,mCAAmC;IACnC,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB,EAAE,kCAAkC;IAC7D,YAAY,EAAE,8BAA8B;AAChD;;AAEA;;IAEI,eAAe;IACf,YAAY;IACZ,mBAAmB,EAAE,uCAAuC;IAC5D,kBAAkB;IAClB,eAAe;IACf,yBAAyB,CAAC,qBAAqB;IAC/C,yBAAyB,EAAE,iBAAiB;IAC5C,YAAY,EAAE,oBAAoB;IAClC,eAAe;IACf,sBAAsB,EAAE,8CAA8C;IACtE,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,wCAAwC;AACxC;;IAEI;QACI,mBAAmB;QACnB,YAAY;IAChB;IACA;QACI,sBAAsB,EAAE,4DAA4D;QACpF,mBAAmB,EAAE,gCAAgC;QACrD,oBAAoB;QACpB,wBAAwB,EAAE,uEAAuE;QACjG,gBAAgB,EAAE,+DAA+D;QACjF,YAAY,EAAE,+CAA+C;QAC7D,eAAe,EAAE,oDAAoD;QACrE,aAAa;QACb,iBAAiB;IACrB;;IAEA;;;QAGI;;SAEC;;QAED,eAAe;IACnB;;IAEA;QACI,sBAAsB,EAAE,4DAA4D;QACpF,mBAAmB,EAAE,gCAAgC;IACzD;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;QAChB,mGAAmG;QACnG,gBAAgB,EAAE,+DAA+D;QACjF,YAAY,EAAE,+CAA+C;QAC7D,eAAe,EAAE,oDAAoD;QACrE,aAAa,EAAE,+CAA+C;QAC9D,qCAAqC;;IAEzC;;IAEA;QACI,6GAA6G;QAC7G,gBAAgB,EAAE,wEAAwE;QAC1F,YAAY,EAAE,iEAAiE;QAC/E,eAAe,EAAE,oDAAoD;QACrE,kBAAkB,EAAE,+CAA+C;QACnE,qCAAqC;;IAEzC;;;AAGJ","sourcesContent":["@font-face {\r\n    font-family: 'Bezier Sans';\r\n    src: url('../../public/fonts/BezierSans.woff2') format('woff2'),\r\n         url('../../public/fonts/BezierSans.woff') format('woff'),\r\n         url('../../public/fonts/BezierSans.ttf') format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n\r\n    font-family: 'Bezier Sans Bold';\r\n    src:\r\n         url('../../public/fonts/BezierSansBold.ttf') format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n  }\r\n  body {\r\n    font-family: 'Bezier Sans', sans-serif;\r\n  }\r\n/* Ваши стили */\r\n\r\n.container-wrapper {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    /* height: 100vh; /* Высота экрана целиком */\r\n}\r\n\r\n.container {\r\n    width: 100%;\r\n    height: 100%;\r\n    padding-bottom: 5%;\r\n    /*padding: 80px 0px 64px;*/\r\n    background-color: #ffffff;\r\n    margin: 0 auto; /* Центрируем контейнер по горизонтали */\r\n    border-radius: 20px;\r\n    display: flex;\r\n    position: relative; /* Для позиционирования псевдоэлемента */\r\n}\r\n\r\n.container::before {\r\n    content: '';\r\n    position: absolute;\r\n    /* bottom: 0; /* Подсветка снизу */\r\n    /* left: 0; */\r\n    width: 100%;\r\n    height: 20px; /* Высота подсветки */\r\n    box-sizing: border-box; /* Учитываем border в размерах */\r\n    pointer-events: none; /* Предотвращаем взаимодействие с псевдоэлементом */\r\n}\r\n\r\n.partners {\r\n\r\n    margin-top: 20px;\r\n    padding: 20px;\r\n    width: 100%; /* Занимаем всю доступную ширину контейнера .container */\r\n    box-sizing: border-box; /* Учитываем padding в общей ширине */\r\n    text-align: center; /* Выравниваем текст по центру */\r\n}\r\n\r\n.text-container {\r\n\r\n    justify-content: center; /* Центрируем контент горизонтально */\r\n    align-items: center;\r\n    padding-top: 30px;\r\n    margin: 0 auto;\r\n    margin-bottom: 32px; /* Отступ от текста 1174x32 */\r\n}\r\n\r\n.text-40,\r\n.text-30,\r\n.text-20 {\r\n    font-family: 'Bezier Sans', sans-serif;\r\n\r\n}\r\n\r\n.text-40 {\r\n    font-family: 'Bezier Sans Bold';\r\n    padding-top: 8%;\r\n    font-size: 40px;\r\n    margin-bottom: 10px;\r\n    line-height: 60px;\r\n}\r\n\r\n\r\n\r\n.text-20 {\r\n    font-family: 'Bezier Sans', sans-serif;\r\n    justify-content: left; \r\n    font-size: 20px;\r\n    padding-left: 10%;\r\n    padding-right: 10%;\r\n}\r\n\r\n.padding-button {\r\n    padding: 20px;\r\n}\r\n\r\n.buttons-container {\r\n    font-family: 'Bezier Sans', sans-serif;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n    gap: 20px;\r\n    width: 100%; \r\n    margin: 0 auto;\r\n    margin-top: 20px;\r\n /* Равномерное распределение между кнопками */\r\n    padding-bottom: 10%;\r\n}\r\n\r\n.button-image{\r\n    margin-top: 5px;\r\n    width: 100px; /* Задайте нужные размеры */\r\n    height: auto;\r\n    display: block;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.partner-description {\r\n    font-family: 'Bezier Sans', sans-serif;\r\n    margin-top: 10px;\r\n    font-size: 14px;\r\n    color: #666;\r\n    text-align: center;\r\n    line-height: 1.5;\r\n}\r\n\r\n.partner-text-k{\r\n    font-family: 'Bezier Sans', sans-serif;\r\n    font-size: 14px;\r\n    margin-left: 8%;\r\n    margin-right: 8%;\r\n    margin-top: 5%;\r\n}\r\n\r\n.buttons-container button {\r\n    width: 390px; /* 376.03pxШирина кнопки */\r\n    height: 400px; /*457.2px Высота кнопки */\r\n    padding: 0; /* Убираем внутренние отступы */\r\n    font-size: 16px;\r\n    background-color: white; /* Белый фон */\r\n    color: black; /* Черный текст */\r\n    border: 1px solid #0014ff; /* Черная обводка */\r\n    cursor: pointer;\r\n    box-sizing: border-box; /* Учитываем padding и border в общей ширине */\r\n    overflow: hidden; /* Обрезаем содержимое, выходящее за пределы кнопки */\r\n    position: relative; /* Позиционируем внутренние элементы относительно кнопки */\r\n    /*font-family: 'Bezier Sans Bold';*/\r\n    font-weight: bold;\r\n    border-radius: 40px;\r\n}\r\n\r\n.buttons-container button:hover {\r\n    background-color: #0014ff; /* Темно-серый фон при наведении */\r\n    color: white; /* Белый текст при наведении */\r\n}\r\n\r\n.partner-button {\r\n\r\n    width: 772.03px;\r\n    height: 51px;\r\n    margin: 20px auto 0; /* Отступ снизу для разделения кнопок */\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n    background-color: #0080ff;/* Светло-серый фон */\r\n    color: rgb(246, 253, 255); /* Черный текст */\r\n    border: none; /* Убираем обводку */\r\n    cursor: pointer;\r\n    box-sizing: border-box; /* Учитываем padding и border в общей ширине */\r\n    font-weight: bold;\r\n    border-radius: 30px;\r\n}\r\n\r\n/* Media query для мобильных устройств */\r\n@media screen and (max-width: 768px) {\r\n\r\n    .partners {\r\n        padding-bottom: 20%;\r\n        height: auto;\r\n    }\r\n    .padding-button {\r\n        flex-direction: column; /* Столбцовое расположение кнопок на мобильных устройствах */\r\n        align-items: center; /* Центрируем кнопки по центру */\r\n        /*margin-top: 20px;*/\r\n        width: calc(100% - 30px); /* Полная ширина кнопок на мобильных устройствах с небольшим отступом */\r\n        max-width: 300px; /* Максимальная ширина кнопок, чтобы не были слишком широкими */\r\n        height: auto; /* Увеличенная высота для мобильных устройств */\r\n        font-size: 24px; /* Увеличенный размер шрифта для лучшей читаемости */\r\n        padding: 20px;\r\n        font-weight: bold;\r\n    }\r\n\r\n    .text-40,\r\n    .text-30,\r\n    .text-20 {\r\n        /*font-family: 'BezierSans', sans-serif;\r\n        font-weight: bold;\r\n        */\r\n        \r\n        max-width: 100%;\r\n    }\r\n\r\n    .buttons-container {\r\n        flex-direction: column; /* Столбцовое расположение кнопок на мобильных устройствах */\r\n        align-items: center; /* Центрируем кнопки по центру */\r\n    }\r\n\r\n    .buttons-container button {\r\n        align-items: center;\r\n        justify-content: center;\r\n        margin-top: 20px;\r\n        /*width: calc(100% - 40px); /* Полная ширина кнопок на мобильных устройствах с небольшим отступом */\r\n        max-width: 300px; /* Максимальная ширина кнопок, чтобы не были слишком широкими */\r\n        height: auto; /* Увеличенная высота для мобильных устройств */\r\n        font-size: 24px; /* Увеличенный размер шрифта для лучшей читаемости */\r\n        padding: 20px; /* Увеличенный отступ для лучшей зоны нажатия */\r\n        font-family: 'BezierSans', sans-serif;\r\n\r\n    }\r\n\r\n    .partner-button {\r\n        /*width: calc(100% - 30px); /* Полная ширина кнопки \"партнёр\" на мобильных устройствах с небольшим отступом */\r\n        max-width: 300px; /* Максимальная ширина кнопки \"партнёр\", чтобы не была слишком широкой */\r\n        height: 70px; /* Увеличенная высота кнопки \"партнёр\" на мобильных устройствах */\r\n        font-size: 18px; /* Увеличенный размер шрифта для лучшей читаемости */\r\n        padding: 15px 20px; /* Увеличенный отступ для лучшей зоны нажатия */\r\n        font-family: 'BezierSans', sans-serif;\r\n\r\n    }\r\n\r\n    \r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
